import { addAllToRecord } from '@ms/yammer-data-support';
import { MessageDeletionOutcome } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import { DeleteMessageFulfilledAction } from '../../../domains/deleteMessage/actions.types';
import {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import {
  ThreadPinToTeamsMeetingFeedFulfilledAction,
  ThreadUnpinFromTeamsMeetingFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import { ThreadMoveCompletedAction } from '../../../domains/threadMove/actions.types';
import {
  removeThreadFromAnyPinnedInstance,
  removeThreadFromAnyPinnedInstanceIfDeleted,
} from '../removeDeletedPinnedThread';
import { ThreadsPinnedToFeeds } from '../types';

export type ThreadsPinnedToTeamsMeetingFeedsAction =
  | DeleteMessageFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | ThreadMoveCompletedAction
  | ThreadPinToTeamsMeetingFeedFulfilledAction
  | ThreadUnpinFromTeamsMeetingFeedFulfilledAction;

const initialState: ThreadsPinnedToFeeds = {};

const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToTeamsMeetingFeedsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'THREAD.PIN_TO_TEAMS_MEETING_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'THREAD.UNPIN_FROM_TEAMS_MEETING_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'MESSAGE.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstanceIfDeleted(
        state,
        action.payload.threadId,
        action.payload.deletionOutcome === MessageDeletionOutcome.THREAD_REMOVED
      );
    case 'THREAD.MOVE_COMPLETED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    default:
      return state;
  }
};

export default reducer;
